var map = {
	"./audio-placeholder": 847,
	"./audio-placeholder.png": 847,
	"./avatar-missing": 541,
	"./avatar-missing.png": 541,
	"./avatar-missing.svg": 950,
	"./header-missing": 796,
	"./header-missing.png": 796,
	"./soapbox-logo": 797,
	"./soapbox-logo-white": 798,
	"./soapbox-logo-white.svg": 798,
	"./soapbox-logo.svg": 797,
	"./video-placeholder": 848,
	"./video-placeholder.png": 848,
	"./void": 849,
	"./void.png": 849,
	"./web-push/web-push-icon_expand": 859,
	"./web-push/web-push-icon_expand.png": 859,
	"./web-push/web-push-icon_favourite": 860,
	"./web-push/web-push-icon_favourite.png": 860,
	"./web-push/web-push-icon_reblog": 861,
	"./web-push/web-push-icon_reblog.png": 861
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 949;